import styled from 'styled-components'

export const H1 = styled.h1`
  color: var(--text-accent-color);
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
  margin-bottom: 8rem;
  @media (min-width: 960px) {
    font-size: 6.4rem;
  }
`
export const H2 = styled.h2`
  color: var(--text-body-color);
  font-size: 2.6rem;
  line-height: 1.3;
`
export const ToolingText = styled.h5`
  color: var(--text-body-color);
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.4;
`
const bodyStyles = `
  color: var(--text-body-color);
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.5;
  @media (min-width: 960px) {
    font-size: 2rem;
  }
`
export const P1 = styled.p`${bodyStyles}`
export const Li = styled.li`${bodyStyles}`